const CustomerManagement = () =>
  import("@/views/customerManagement/customerManagement.vue");
const CustomerListing = () =>
  import("@/views/customerManagement/customerListing.vue");
const order = () => import("@/views/customerManagement/orderDetails.vue");
const awardBenefits = () =>
  import("@/views/customerManagement/awardBenefits.vue");
const raiseServiceRequest = () =>
  import("@/views/customerManagement/raiseServiceRequest.vue");
const serviceRequest = () =>
  import("@/views/customerManagement/serviceRequest.vue");
const serviceRequestDetails = () =>
  import("@/views/customerManagement/serviceRequestDetails.vue");
const createAddress = () =>
  import("@/views/customerManagement/addressCreate.vue");

export default {
  path: "customer-management",
  meta: { label: "Customer Management" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: CustomerManagement,
    },
    {
      path: ":id",
      name: "Customer-Management-Listing",
      meta: {
        label: "Customer Management Details",
        requiresAuth: true,
      },
      component: CustomerListing,
    },
    {
      path: ":customerId/orderDetail/:id",
      name: "order-details",
      meta: {
        label: "Order Details",
        requiresAuth: true,
      },
      component: order,
    },
    {
      path: "/createAddress",
      name: "address-create",
      meta: {
        label: "Create Address",
        requiresAuth: true,
      },
      component: createAddress,
    },

    {
      path: "/awardBenefits",
      name: "award-benefits",
      meta: {
        label: "Award Benifits",
        requiresAuth: true,
      },
      component: awardBenefits,
    },
    {
      path: "/serviceTicket",
      name: "service-request",
      meta: {
        label: "Service Request",
        requiresAuth: true,
      },
      component: serviceRequest,
    },
    {
      path: ":id",
      name: "raise-service-request",
      meta: {
        label: "Raise Service Request",
        requiresAuth: true,
      },
      component: raiseServiceRequest,
    },
    {
      path: ":customerId/serviceDetail/:id",
      name: "service-request-details",
      meta: {
        label: "Service Request Details",
        requiresAuth: true,
      },
      component: serviceRequestDetails,
    },
  ],
};
